import _ from "lodash";
import moment from "moment";

export default {
    SET_MODE(state, data) {
        state.mode = data
    },
    SET_SELECTED_CATEGORY(state, data) {
        state.selectedCategory = data
    },
    SET_CHANNEL_TIME_FROM(state, data) {
        state.channelTimeFrom = data
    },
    SET_CHANNEL_TIME_TO(state, data) {
        state.channelTimeTo = data
    },
    SET_CUSTOM_CHANNEL_IDS(state, data) {
        state.customChannelIds = data
    },
    SET_LIVE_MODE_START_FROM(state, data) {
        state.liveModeStartFrom = data
    },
    REMOVE_CHANNEL_ID(state, data) {
        state.channelId.filter(n => n !== data);
    },
    SET_VERSION_ID(state, data) {
        state.kind[data.kind].versionId = data.version_id
        state.kind[data.kind].versionName = data.version_name
    },
    SET_ORIGIN_ID() {
        // TODO: 一旦固定値にするため更新させない
        //state.kind["engine"].originId = data.engineOriginId
        //state.kind["handling"].originId = data.maneuveringOriginId
        //state.kind["aisea_alert"].originId = data.engineOriginId
    },
    SET_CHANNEL_GROUP_FOCUS_POINT_MAP(state, data) {
        state.channelGroupFocusPointMap[data.channelGroup] = data.time
    },
    SET_CHANNEL_DETAIL_DATA(state, data) {
        state.channelDetailDataMap = data;
    },
    PUSH_UNSUBSCRIBE(state, data) {
        state.unsubscribes.push(data);
    },
    UNSUBSCRIBE_FIRE_STORE(state) {
        if (state.unsubscribes.length !== 0) {
            state.unsubscribes.forEach(unsubscribe => {
                unsubscribe();
            });
            state.unsubscribes = [];
        }
    },
    PUSH_UNSUBSCRIBE_FOR_CHART(state, data) {
        state.unsubscribesForChart.push(data);
    },
    UNSUBSCRIBE_FIRE_STORE_FOR_CHART(state) {
        if (state.unsubscribesForChart.length !== 0) {
            state.unsubscribesForChart.forEach(unsubscribe => {
                unsubscribe();
            });
        }
    },
    SET_LATEST_CHANNEL_DATA(state, data) {
        state.latestChannelData = data;
    },
    ADD_ALERT_SUMMARY_LIVE_DATAS(state, data) {
        state.alertSummaryLiveDatas.unshift(data);
    },
    ADD_EVENT_SUMMARY_LIVE_DATAS(state, data) {
        state.eventSummaryLiveDatas.unshift(data);
    },
    RESET_ALERT_SUMMARY_LIVE_DATAS(state) {
        state.alertSummaryLiveDatas = [];
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == "alert" })
        if (index >= 0) {
            state.channelGroupData[index].channels = []
        }
    },
    RESET_EVENT_SUMMARY_LIVE_DATAS(state) {
        state.eventSummaryLiveDatas = [];
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == "event" })
        if (index >= 0) {
            state.channelGroupData[index].channels = []
        }
    },
    SET_CHANNEL_GROUP_CHANNELS(state, data) {
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == data.targetChannelGroup })
        if (index >= 0) {
            state.channelGroupData[index].channels[data.channel.channel_id] = {
                channel_name: data.channel.channel_name,
                value_string_options: data.channel.value_string_options,
                value_number_range: data.channel.value_number_range,
                unit: data.channel.unit,
                kind: data.kind,
            }
        }
    },
    SET_CHANNEL_GROUP_STATUS_DATA(state, data) {
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == data.targetChannelGroup })
        if (index >= 0) {
            state.channelGroupData[index].channels = data.channel
        }
    },
    SET_REFERENCED_CHANNEL_ID_MAP(state, data){
        state.referencedChannelIdMap = data;
    },
    SET_CHANNEL_MASTER(state, data) {
        state.channelMaster[data.kind] = data.channelMaster
    },
    SET_PREV_FIRESTORE_DOCUMENT(state, data) {
        state.prevFirestoreDocument = data;
    },
    SET_MONITORING_VESSEL_ENGINE_START(state, nowEpochValue) {
        state.monitoringVesselEngineStart = nowEpochValue;
    },
    ADD_X_ZOOM_COUNT(state) {
        state.xZoomCount++
    },
    REDUCE_X_ZOOM_COUNT(state) {
        state.xZoomCount--
    },
    RESET_X_ZOOM_COUNT(state) {
        state.xZoomCount = 0
    },
    SET_X_ZOOM_STORED_RANGE(state, data) {
        state.xZoomStoredRange = data;
    },
    SET_LIVE_DATA_TIME_RANGE(state, data) {
        state.liveDataTimeRange = data
    },
    ZOOM_IN_LIVE_CHANNEL_TIME(state) {
        state.liveDataTimeRangeIndex++
        state.liveDataTimeRange = state.liveDataTimeRangeOptions[state.liveDataTimeRangeIndex]
    },
    ZOOM_OUT_LIVE_CHANNEL_TIME(state) {
        state.liveDataTimeRangeIndex--
        state.liveDataTimeRange = state.liveDataTimeRangeOptions[state.liveDataTimeRangeIndex]
    },
    RESET_LIVE_CHANNEL_TIME(state) {
        state.liveDataTimeRangeIndex = 0
        state.liveDataTimeRange = 60
    },
    ADD_ALERT_OCCUR_TIME(state, data) {
        if (data.forceFlag) {
            let payload = {}
            payload[data.channel_id] = moment(data.channel_time).local().format("YYYY/MM/DD HH:mm:ss")
            state.alertOccurTimeMap = {
                ...state.alertOccurTimeMap,
                ...payload
            }
        } else {
             // 該当のchannel_idの発生時間が未登録か、取得不可か、新しい発生時間が既に登録されている発生時間よりも新しければ発生時間を更新する
            if (!state.alertOccurTimeMap[data.channel_id] || state.alertOccurTimeMap[data.channel_id] == "取得不可" || (
                moment(state.alertOccurTimeMap[data.channel_id]).valueOf() < moment(data.channel_time).valueOf()
            )) {
                let payload = {}
                payload[data.channel_id] = moment(data.channel_time).local().format("YYYY/MM/DD HH:mm:ss")
                state.alertOccurTimeMap = {
                    ...state.alertOccurTimeMap,
                    ...payload
                }
            }
        }
    },
    SET_NOT_FOUND_ALERT_OCCUR_TIME(state, data) {
        let payload = {}
        payload[data.channel_id] = "取得不可"
        state.alertOccurTimeMap = {
            ...state.alertOccurTimeMap,
            ...payload
        }
    },
    RESET_ALERT_OCCUR_TIME(state) {
        state.alertOccurTimeMap = {}
    }
}